import "core-js/modules/es.array.push.js";
import request from "../../util/request";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Toolbox.vue',
  data() {
    return {
      roleId: sessionStorage.getItem("roleId"),
      localName: '',
      toolId: '',
      tool: [],
      ticket: [],
      reData: {},
      formVisible: false,
      form: {
        localName: '',
        capIndex: ''
      },
      form2Visible: false,
      form2: {
        localName: '',
        capIndex: '',
        allocations: ''
      },
      currentPage: 1,
      total: 0,
      pageSize: 5,
      pageSizes: [5, 10, 15, 20, 25, 30],
      options: [],
      value1: [],
      value2: [],
      rule: {
        localName: [{
          required: true,
          message: '请输入安全帽ID',
          trigger: 'blur'
        }],
        capIndex: [{
          required: true,
          message: '请输入安全帽号',
          trigger: 'blur'
        }],
        factoryDate: [{
          required: true,
          message: '请选择安全帽系统出厂时间',
          trigger: 'blur'
        }],
        mcFactoryDate: [{
          required: true,
          message: '请选择安全帽模具出厂时间',
          trigger: 'blur'
        }]
      },
      capAllocations: [{
        allocations: 0,
        localName: '未分配'
      }, {
        allocations: 1,
        localName: '已分配'
      }, {
        allocations: 2,
        localName: '遗失'
      }, {
        allocations: 3,
        localName: '损坏'
      }]
    };
  },
  created() {
    this.load();
    // this.load1();
  },

  mounted() {
    console.log(this.$refs);
  },
  methods: {
    //时间格式
    formatDate(value, fmt) {
      if (value == null || value == '') {
        return "";
      }
      let getDate = new Date(value);
      let o = {
        'M+': getDate.getMonth() + 1,
        'd+': getDate.getDate(),
        'h+': getDate.getHours(),
        'm+': getDate.getMinutes(),
        's+': getDate.getSeconds(),
        'q+': Math.floor((getDate.getMonth() + 3) / 3),
        'S': getDate.getMilliseconds()
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        }
      }
      return fmt;
    },
    load() {
      console.log("234567890");
      request.post('/cap/queryList').then(res => {
        console.log(res);
        this.ticket = res;
        console.log(this.ticket);
        this.total = res.length;
        this.getPageInfo();
      });
      request.post('/cap/selectCapTime').then(res => {
        console.log(res);
        if (res.length !== 0) {
          this.$confirm('有安全帽设备即将到达使用期限，请及时处理!', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '关闭',
            type: 'warning',
            closeOnClickModal: false
          }).then(() => {}).catch(() => {});
        }
      });
    },
    load1() {
      // let date1;
      // let date2;
      request.post('/cap/selectCapTime').then(res => {
        console.log(res);
        this.ticket = res;
        console.log(this.ticket);
        this.total = res.length;
        this.getPageInfo();
      });
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      // this.load();
      this.getPageInfo();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      // this.load();
      this.getPageInfo();
    },
    // 获取当前页的数据信息
    getPageInfo() {
      // this.load();
      console.log("进入分页方法");
      //清空pageTicket中的数据
      this.tool = [];
      // 获取当前页的数据
      for (let i = (this.currentPage - 1) * this.pageSize; i < this.total; i++) {
        console.log(this.ticket[0]);
        //把遍历的数据添加到pageTicket里面
        this.tool.push(this.ticket[i]);
        //判断是否达到一页的要求
        if (this.tool.length === this.pageSize) break;
      }
    },
    //搜索
    sele() {
      console.log("123");
      console.log(this.toolName);
      if (this.localName == null || this.localName == "") {
        this.$message({
          message: '请输入安全帽名',
          type: 'warning'
        });
        return;
      }
      // let Map = {
      //   "page": this.currentPage,
      //   "size": this.pageSize,
      //   "localName": this.localName
      // }
      request.post('/cap/select', this.localName).then(res => {
        console.log(res);
        // this.ticket = res.data.lists
        this.ticket = res;
        // this.total=res.data.lists.length;
        // this.total=res.data.total;
        this.total = res.length;
        // if (res.data.list.length == 0) {
        //   this.ticket = res.data.list
        //   this.total = res.data.list.length;
        // }
        this.getPageInfo();
        console.log(res);
        // for (let i = 0; i < this.tool.length; i++) {
        //     console.log("tool.name"+this.tool[i].localName)
        // }
        this.$message({
          message: '查询成功',
          type: 'success'
        });
      });
    },
    //删除操作
    dele(id, allocations) {
      console.log("222");
      console.log(id);
      console.log(allocations);
      // eslint-disable-next-line no-unused-vars
      if (allocations == 1) {
        this.$confirm('该安全帽已被分配，请解除分配后再删除', '提示', {
          type: "warning"
        }).then(response => {
          console.log(response);
        }).catch(() => {});
      } else {
        this.$confirm('您确认删除吗', '确认删除', {
          type: "warning"
        }).then(response => {
          console.log(response);
          request.post('/cap/delete', id).then(res => {
            console.log("33333");
            console.log(res);
            console.log(res.length);
            console.log(this.total + "0000");
            if (res.length == this.total) {
              this.$message.error('删除失败');
            } else {
              this.$message.success('删除成功');
            }
            //在第二页删除完数据，第一页还有数据，能够正确展示出第一页的数据
            this.currentPage = 1;
            this.load();
          });
        }).catch(() => {});
      }
    },
    //查看仪器表
    check(toolid) {
      console.log("111222333");
      console.log(toolid);
      //带参数路径的路由跳转，点击查看仪器表跳转仪器表的页面
      // this.$router.push({name:'Instrument' ,params:{id:toolid}})
      this.$router.push({
        path: 'instrument',
        query: {
          id: toolid
        }
      });
    },
    //修改操作
    toupdate(row) {
      console.log("qqqq");
      this.form2 = {};
      this.form2Visible = true; //打开弹窗
      console.log("ttt");
      this.$nextTick(() => {
        console.log("tttt");
        //表单验证清除，第一遍点显示出不为空，第二遍清除第一遍的判断，又变为初始化的样子
        setTimeout(() => {
          this.$refs.form2.clearValidate();
        }, 0);
      });
      this.form2 = JSON.parse(JSON.stringify(row)); //这种拷贝方式，form2改变，row不会改变，点击确定保存后才会同步更改
      if (JSON.parse(JSON.stringify(row.allocations)) == 0) {
        // this.form2.allocations = "未分配"
        this.capAllocations.allocations = 0;
        this.capAllocations.localName = "未分配";
      } else if (JSON.parse(JSON.stringify(row.allocations)) == 1) {
        // this.form2.allocations = "已分配"
        this.capAllocations.allocations = 1;
        this.capAllocations.localName = "已分配";
      } else if (JSON.parse(JSON.stringify(row.allocations)) == 2) {
        // this.form2.allocations = "遗失"
        this.capAllocations.allocations = 2;
        this.capAllocations.localName = "遗失";
      } else if (JSON.parse(JSON.stringify(row.allocations)) == 3) {
        // this.form2.allocations = "损坏"
        this.capAllocations.allocations = 3;
        this.capAllocations.localName = "损坏";
      }
      this.reData = JSON.parse(JSON.stringify(row));
    },
    save2() {
      console.log("rrrr");
      console.log(this.form2.allocations);
      let b = false;
      for (let i = 0; i < this.ticket.length; i++) {
        //修改后的组号不能和表格其他一样，但是可以和当前的一样
        if (this.form2.capIndex == this.ticket[i].capIndex && this.form2.capIndex != this.reData.capIndex) {
          this.$message({
            message: '安全帽号不能重复',
            type: 'warning'
          });
          b = true;
          break;
        }
        if (this.form2.localName === this.ticket[i].localName && this.form2.localName !== this.reData.localName) {
          this.$message({
            message: '安全帽名不能重复',
            type: 'warning'
          });
          b = true;
          break;
        }
      }
      if (b) {
        return false;
      }
      //判断表单输入框不能为空
      if (this.form2.localName == null || this.form2.localName == '' || this.form2.localName == undefined) {
        this.$message({
          message: '安全帽名不能为空',
          type: 'warning'
        });
        return false;
      }
      console.log("-----uu");
      if (this.form2.capIndex == null || this.form2.capIndex == '' || this.form2.capIndex == undefined) {
        this.$message({
          message: '安全帽号不能为空',
          type: 'warning'
        });
        return false;
      }
      console.log("-----kk");
      // eslint-disable-next-line no-unused-vars
      this.form2.deviceId = "CE:CE:46:B0:9F:91";
      this.form2.uuid = "25AE1441-05D3-4C5B-8281-93D4E07420CF";
      this.form2.readUUID = "25AE1442-05D3-4C5B-8281-93D4E07420CF";
      this.form2.writeUUID = "25AE1443-05D3-4C5B-8281-93D4E07420CF";
      this.form2.indicateUUID = "25AE1444-05D3-4C5B-8281-93D4E07420CF";
      request.post('/cap/update', this.form2).then(res => {
        console.log(res);
        console.log(this.form2);
        this.$message({
          message: '修改成功',
          type: 'success'
        });
        this.load();
        this.form2Visible = false; //关闭弹窗
      });
    },

    //新建安全帽
    handleAdd() {
      this.form = {};
      this.formVisible = true; //打开弹窗
      console.log("mmmmm");
      this.$nextTick(() => {
        console.log("tttt");
        setTimeout(() => {
          this.$refs.form.clearValidate();
        }, 0);
      });
      console.log("xxxxx");
    },
    test() {
      this.$confirm(true, '报告上传提示', {
        confirmButtonText: '确定',
        cancelButtonText: '关闭',
        type: 'success',
        closeOnClickModal: false
      }).then(() => {
        console.log("1");
      }).catch(() => {
        console.log("0");
      });
    },
    save1() {
      console.log("1111");
      console.log(this.ticket);
      //创建人是登录的用户
      this.form.createBy = sessionStorage.getItem("userName");
      this.form.deviceId = "CE:CE:46:B0:9F:91";
      this.form.uuid = "25AE1441-05D3-4C5B-8281-93D4E07420CF";
      this.form.readUUID = "25AE1442-05D3-4C5B-8281-93D4E07420CF";
      this.form.writeUUID = "25AE1443-05D3-4C5B-8281-93D4E07420CF";
      this.form.indicateUUID = "25AE1444-05D3-4C5B-8281-93D4E07420CF";
      console.log(this.form.createBy);
      let b = false;
      for (let i = 0; i < this.ticket.length; i++) {
        // if ( this.form.capIndex === this.tool[i].capIndex && this.form.capIndex !==this.reData.capIndex) {
        if (this.form.capIndex === this.ticket[i].capIndex && this.form.capIndex !== this.reData.capIndex) {
          this.$message({
            message: '安全帽号不能重复',
            type: 'warning'
          });
          b = true;
          break;
        }
        // if (this.form.localName === this.tool[i].localName  && this.form.localName !==this.reData.localName) {
        if (this.form.localName === this.ticket[i].localName && this.form.localName !== this.reData.localName) {
          this.$message({
            message: '安全帽ID不能重复',
            type: 'warning'
          });
          b = true;
          break;
        }
      }
      if (b) {
        return false;
      }
      if (this.form.localName == null || this.form.localName == '' || this.form.localName == undefined) {
        this.$message({
          message: '安全帽ID不能为空',
          type: 'warning'
        });
        return false;
      }
      console.log("-----uu");
      if (this.form.capIndex == null || this.form.capIndex == '' || this.form.capIndex == undefined) {
        this.$message({
          message: '安全帽号不能为空',
          type: 'warning'
        });
        return false;
      }
      console.log("-----kk");
      if (this.form.factoryDate == null || this.form.factoryDate == '' || this.form.factoryDate == undefined) {
        this.$message({
          message: '安全帽系统出厂时间不能为空',
          type: 'warning'
        });
        return false;
      }
      if (this.form.mcFactoryDate == null || this.form.mcFactoryDate == '' || this.form.mcFactoryDate == undefined) {
        this.$message({
          message: '安全帽模具出厂时间不能为空',
          type: 'warning'
        });
        return false;
      }

      // eslint-disable-next-line no-unused-vars
      request.post('/cap/addCap', this.form).then(res => {
        console.log(this.form);
        this.$message({
          message: '添加成功',
          type: 'success'
        });
        this.load();
        this.formVisible = false; //关闭弹窗
      });
    },

    refresh() {
      this.localName = '';
      this.currentPage = 1;
      this.load();
      this.$message({
        message: '刷新成功',
        type: 'success'
      });
    }
  }
};